package top.wcpe.allincore.ui.runtime.ir.subscribe

/**
 * DSL 值层的订阅包装：DSL 中 `var s = net.subscribe(...)` 拿到的运行时值。
 *
 * <p>当前仅暴露 cancel 能力；后续可扩展 MemberCall 分支让 DSL 中 `s.cancel()` 生效。</p>
 */
class SubscriptionValue(private val subscription: Subscription) {

    /** 取消底层订阅（幂等）。 */
    fun cancel() {
        subscription.cancel()
    }

    /** 是否已取消。 */
    fun isCancelled(): Boolean = subscription.isCancelled()

    /** 获取底层 Subscription（供测试使用）。 */
    fun getSubscription(): Subscription = subscription

    override fun toString(): String = "SubscriptionValue(cancelled=${subscription.isCancelled()})"
}
